module.exports = __webpack_public_path__ + "static/media/reciklirani.a949420b.jpg";